module.exports = __webpack_public_path__ + "static/media/page.20185743.svg";